import React, { useState, useEffect } from "react";
import axios from "axios";
import "../../barcodeform.css";

import Select from "react-select";
import jQuery from "jquery";
import { CSVLink } from "react-csv";
export default function GetDriverOrdersbyRange() {
  const API_URL = process.env.REACT_APP_API_URL;
  const [barcode, setBarcode] = useState("");
  const [shipmentDetails, setShipmentDetails] = useState([]);
  const [loading, setLoading] = useState(false);

  const $ = jQuery.noConflict();

  const [selectedPaymentType, setSelectedPaymentType] = useState("All");
  useEffect(() => {
    $(".btn-demo.import").on("click", function () {
      $(".nalier.middle-center.fade").css("display", "block");
      $(".nalier.middle-center.fade").addClass("in");
    });

    $(".close.h-close").on("click", function () {
      $(".nalier.middle-center.fade.in").css("display", "none");
      $(".nalier.middle-center.fade").removeClass("in");
    });
  }, []);

  const buttonsyle = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginRight: "10px",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
  };
  const buttonsyle1 = {
    background: "#00a6ed",
    color: "#fff",
    padding: "3px",
    marginLeft: "75%",
    borderColor: "#00a6ed",
    cursor: "pointer",
    marginTop: "3%",
    marginBottom: "2%",
  };

  const [msg, setMsg] = useState("");
  const [errormsg, setError] = useState("");

  useEffect(() => {
    // Fetch drivers from the API on component mount
    fetchDrivers();
    getUserList();
  }, []);

  const [scaninfo, setScaninfo] = useState({
    driver: "",
  });
  const [drivers, setDrivers] = useState();
  const [awb, setAwb] = useState();
  const fetchDrivers = async () => {
    try {
      // Replace this API endpoint with the actual one that fetches drivers based on the emirate
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getAllDrivers`
      );

      if (response.data.success) {
        const driversData = response.data.data; // The array of driver objects

        // Map the response to extract driverId and name
        const driversList = driversData.map((driver) => ({
          driver_id: driver.driverId,
          driver_name: driver.name,
        }));

        // Set the drivers state
        setDrivers(driversList);
      } else {
        console.error("Error fetching drivers for emirate:");
      }
    } catch (error) {
      console.error("Error fetching drivers:", error);
    }
  };

  const [users, setusers] = useState();
  const getUserList = async () => {
    const API_PATH = `${API_URL}shypvdriverapp/personnel/getPersonnels`;

    // Send a GET request to the new API
    try {
      const res = await axios.get(API_PATH);

      console.log(res.data); // Log the response to inspect it

      // Check if the response contains 'data' and if it's an array
      if (res.data && res.data.success && Array.isArray(res.data.data)) {
        setusers(res.data.data); // Update the personnel list in the state
      } else {
        console.log(
          "No personnel data found in the response or response is not successful"
        );
      }
    } catch (err) {
      console.log("Error fetching personnel list:", err);
    }
  };

  console.log("drivers:", drivers);
  console.log("scan:", scaninfo);
  console.log("users:", users);

  const getDetails = async () => {
    try {
      const response = await axios.post(
        `${API_URL}shypvdriverapp/jobs/assignedOrderDateRangeDetails`,
        // 'https://driver-api.shypv.com/shypvdriverapp/jobs/assignedOrderDateRangeDetails',
        {
          driverId: driver,
          fromDate: datechosenfrom,
          toDate: datechosento,
        },
        {
          headers: {
            "Content-Type": "application/json",
          },
        }
      );

      console.log("Response Data:", response.data);

      // Handle response data
      if (response.data.success) {
        setShipmentDetails(response.data.data || []);
        fetchDriverInfo(driver);
        if (response.data.data.length === 0) {
          setError("Booking details not found");
        } else {
          setError("");
        }
      } else {
        setShipmentDetails([]);
        setError("Booking details not found");
      }
    } catch (err) {
      console.error("Error:", err.response || err.message);
      setError("An error occurred while fetching details");
    }
  };

  const [driverdata, setdriverdata] = useState({
    driverid: "",
    team: "",
    zone: "",
  });

  const fetchDriverInfo = async (driverId) => {
    try {
      const response = await axios.get(
        `${API_URL}shypvdriverapp/driver/getDriver`,
        {
          params: { driverId },
        }
      );

      console.log("Driver Info:", response.data);
      if (response.data.success) {
        const driverInfo = response.data.data;

        setdriverdata({
          driverid: driverInfo.driverId || "",
          team: driverInfo.team?.teamName || "",
          zone: `${driverInfo.zone?.district || ""} - ${
            driverInfo.zone?.emirates || ""
          }`,
        });
      } else {
        setdriverdata({ driverid: driverId, team: "", zone: "" });
      }
      // Optionally update state or show UI
      // setDriverDetails(response.data);
    } catch (error) {
      console.error("Error fetching driver info:", error);
      setdriverdata({ driverid: driverId, team: "", zone: "" });
    }
  };

  const [errorNew, seterrorNew] = useState("");

  const getDriverName = (driverId) => {
    const driver = drivers.find(
      (driver) => driver.driver_id === parseInt(driverId)
    );
    return driver ? driver.driver_name : "Unknown"; // Default to 'Unknown' if not found
  };

  const getUserName = (userid) => {
    console.log("user is ", userid);
    const user = users.find((user) => user.personnel_id === parseInt(userid));

    return user ? user.personnel_name : "Unknown"; // Default to 'Unknown' if not found
  };

  const [allStatus, setallStatus] = useState();
  useEffect(() => {
    // Make the API call when the component mounts
    axios
      .get(`${API_URL}shypvdriverapp/jobs/getAllStatus`)
      .then((response) => {
        setallStatus(response.data.data); // Store the data in state
        setLoading(false); // Set loading to false when done
      })
      .catch((err) => {
        setError(err); // Store the error in state if something goes wrong
        setLoading(false); // Set loading to false even if there's an error
      });
  }, []);

  console.log("all", allStatus);

  //   const [updatedDetails, setUpdatedDetails] = useState(shipmentDetails);
  const [newStatus, setnewStatus] = useState(0);
  // Handle status change
  const handleStatusChange = (index, newStatus) => {
    setnewStatus(newStatus);
    // Create a copy of the current shipment details
    const updatedShipmentDetails = [...shipmentDetails];

    // Update the status at the specified index
    updatedShipmentDetails[index].status = newStatus;

    // Update the state with the new shipment details array
    setShipmentDetails(updatedShipmentDetails);
  };

  const handleAwbChange = (e) => {
    // Update the input field value
    setAwb(e.target.value);
  };

  function resetData() {
    setShipmentDetails([]);
    setAwb("");
  }
  console.log("shipmentDetails", shipmentDetails);

  const [datechosenfrom, setdatechosenfrom] = useState();
  const [datechosento, setdatechosento] = useState();
  const [driver, setdriverchosen] = useState();

  const handleFilterChange = (e) => {
    setSelectedPaymentType(e.target.value);
  };

  const filteredShipmentDetails = shipmentDetails.filter((data) => {
    if (selectedPaymentType === "COD") {
      return data.paymentType === selectedPaymentType; // Filter by COD or NON COD
    } else if (selectedPaymentType === "NON COD") {
      return data.paymentType !== "COD"; // Filter by COD or NON COD
    } else if (selectedPaymentType === "DELIVERED") {
      return data.latestStatus === "DELIVERED"; // Filter by COD or NON COD
    } else if (selectedPaymentType === "PENDING") {
      return data.latestStatus !== "DELIVERED"; // Filter by COD or NON COD
    } else {
      return true; // Show all
    }
  });

  const totalCod =
    filteredShipmentDetails &&
    filteredShipmentDetails
      .filter((data) => data.latestStatus?.toLowerCase() === "delivered")
      .reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

  const [actualCollectedMap, setActualCollectedMap] = useState({});

  // Update actualCollectedMap when the component mounts
  useEffect(() => {
    const initialMap = {};
    filteredShipmentDetails.forEach((item) => {
      initialMap[item.bookingId] = item.cashCollected ?? 0;
    });
    setActualCollectedMap(initialMap);
  }, [filteredShipmentDetails]);

  // Calculate the sum of all values in actualCollectedMap
  const getTotalActualCollected = () => {
    return filteredShipmentDetails
      .filter((data) => data.latestStatus?.toLowerCase() === "delivered")
      .reduce((sum, data) => {
        const collectedAmount = actualCollectedMap[data.bookingId];
        return sum + (collectedAmount ? parseFloat(collectedAmount) : 0); // Safely sum the values
      }, 0);
  };

  const generateCSVData = (type) => {
    // Filter data based on the passed type
    let filteredData = shipmentDetails;

    if (type === "DELIVERED") {
      console.log("dele");
      filteredData = shipmentDetails.filter(
        (data) => data.latestStatus === "DELIVERED"
      );
    } else if (type === "PENDING") {
      // filteredData = shipmentDetails.filter((data) => data.paymentType !== "COD");
      filteredData = shipmentDetails.filter(
        (data) => data.latestStatus !== "DELIVERED"
      );
      //   filteredData = shipmentDetails.filter((data) => data.latestStatus && data.latestStatus.trim().toUpperCase() !== "DELIVERED");
    } else if (type === "nonCOD") {
      filteredData = shipmentDetails.filter(
        (data) => data.paymentType !== "COD"
      );
    } else if (type === "COD") {
      filteredData = shipmentDetails.filter(
        (data) => data.paymentType === "COD"
      );
    } else {
      filteredData = shipmentDetails;
    }

    const csvData = filteredData.map((data) => ({
      // ── Added fields (match the Live View / Emirates export layout) ──
      CustawbNo: data.custAwb || "",
      TimexAWB: data.bookingId || "",
      City: data.city || "",
      Destination: data.city || "",
      Type: data.type || "",
      "Task Status": data.latestStatus || "",
      "Assigned Date": data.assignedDate ? new Date(data.assignedDate).toLocaleDateString() : "",
      "Order Creation Date": "",
      SRVTYPE: "",
      TOC: "",
      Weight: data.consolidatedWeight != null ? data.consolidatedWeight : "",
      AWB: data.bookingId,
      Status: data.latestStatus,
      "Last Transit Date": new Date(data.lastUpdatedDate)
        .toISOString()
        .split("T")[0],
      "Last Transit Time": new Date(data.lastUpdatedDate).toLocaleTimeString(),
      Courier: `${driver} - ${data.courier}`,
      courier_team: driverdata.team,
      courier_zone: driverdata.zone,
      Shipper: data.shipperDetails?.name || "",
      Consignee: data.consigneeDetails?.name || "",
      "Payment Type": data.paymentType,
      COD:
        data.latestStatus?.toLowerCase() === "delivered" ? data.codDetails : 0,
      "Cash Collected":
        data.latestStatus?.toLowerCase() === "delivered"
          ? data.cashCollected
          : "",
      "Cash Difference":
        data.latestStatus?.toLowerCase() === "delivered"
          ? data.codDetails - data.cashCollected
          : 0,

      "Updated By": data.updatedBy,
    }));

    const totalCodcsv =
      filteredData &&
      filteredData
        .filter((data) => data.latestStatus?.toLowerCase() === "delivered")
        .reduce((acc, data) => acc + (parseFloat(data.codDetails) || 0), 0);

    // Add the Total COD as a row at the end of the CSV
    const csvDataWithTotal = [
      ...csvData,
      ...(type && type !== "nonCOD"
        ? [
            {
              AWB: "Total COD:",
              Status: "",
              "Last Transit Date": "",
              "Last Transit Time": "",
              Courier: "",
              courier_team: "",
              courier_zone: "",
              Shipper: "",
              Consignee: "",
              "Payment Type": "",
              COD: totalCodcsv, // Add totalCod only if it's not 'NON COD'
              ActualCollected: getTotalActualCollected(),
              "Updated By": "",
            },
          ]
        : []),
    ];

    // Returning the result

    return csvDataWithTotal;
  };

  // Add the Total COD as a row at the end of the CSV

  // CSV headers
  const csvHeaders = [
    // ── Emirates / Live-View layout columns ──
    { label: "CustawbNo", key: "CustawbNo" },
    { label: "TimexAWB", key: "TimexAWB" },
    { label: "Last Transit Date", key: "Last Transit Date" },
    { label: "Order Creation Date", key: "Order Creation Date" },
    { label: "Task Status", key: "Task Status" },
    { label: "Customer Name", key: "Consignee" },
    { label: "City", key: "City" },
    { label: "Shipper", key: "Shipper" },
    { label: "Driver", key: "Courier" },
    { label: "Driver Team", key: "courier_team" },
    { label: "Driver Zone", key: "courier_zone" },
    { label: "AWB", key: "CustawbNo" },
    { label: "Weight", key: "Weight" },
    { label: "Destination", key: "Destination" },
    { label: "Status", key: "Status" },
    { label: "Type", key: "Type" },
    { label: "Assigned Date", key: "Assigned Date" },
    { label: "SRVTYPE", key: "SRVTYPE" },
    { label: "TOC", key: "TOC" },
    // ── Operations columns ──
    { label: "Last Transit Time", key: "Last Transit Time" },
    { label: "Courier", key: "Courier" },
    { label: "Courier team", key: "courier_team" },
    { label: "Courier zone", key: "courier_zone" },
    { label: "Consignee", key: "Consignee" },
    { label: "Payment Type", key: "Payment Type" },
    { label: "COD", key: "COD" },
    { label: "Cash Collected", key: "Cash Collected" },
    { label: "Cash Difference", key: "Cash Difference" },
    { label: "Updated By", key: "Updated By" },
  ];

  const csvDataForDownload = generateCSVData("DELIVERED"); // Replace with 'pending' for pending records
  const csvDataForDownloadAll = generateCSVData("ALL"); // Replace with 'pending' for pending records
  const csvDataForDownloadPending = generateCSVData("PENDING"); // Replace with 'pending' for pending records
  const csvDataForNonCod = generateCSVData("nonCOD"); // Replace with 'pending' for pending records
  const csvDataForCOD = generateCSVData("COD"); // Replace with 'pending' for pending records

  const hasDeliveredRecords = shipmentDetails.some(
    (data) => data.latestStatus.toUpperCase() === "DELIVERED"
  );

  // Handle filter change

  const [searchQuery, setSearchQuery] = useState("");

  const filteredDrivers = Array.isArray(drivers)
    ? drivers.filter((driver) =>
        driver.driver_name.toLowerCase().includes(searchQuery.toLowerCase())
      )
    : [];

  const driverOptions = filteredDrivers.map((driver) => ({
    value: driver.driver_id,
    label: `${driver.driver_id} - ${driver.driver_name}`,
  }));

  const handleChange = (selectedOption) => {
    setdriverchosen(selectedOption.value);
  };

  return (
    <div>
      <div className="form-container">
        <h4>Get Report</h4>
        <div className="row">
          <div className="col-md-8">
            <div className="row">
              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="driver">Date:</label>
                  <input
                    type="date"
                    id="date"
                    value={datechosenfrom}
                    onChange={(e) => setdatechosenfrom(e.target.value)}
                  />
                </div>
              </div>

              <div className="col-md-4">
                <div className="form-group">
                  <label htmlFor="driver">Date:</label>
                  <input
                    type="date"
                    id="date"
                    value={datechosento}
                    onChange={(e) => setdatechosento(e.target.value)}
                  />
                </div>
              </div>
            </div>

            {/* Driver Selection */}
            <div className="row">
              <div className="col-md-8">
                <div className="form-group">
                  <label htmlFor="driver">Select Driver:</label>
                  <Select
                    options={driverOptions}
                    value={driverOptions.find(
                      (option) => option.value === scaninfo.driver
                    )}
                    onChange={handleChange}
                    placeholder="Select a driver"
                    onInputChange={(newValue) => setSearchQuery(newValue)} // Update search query
                    isSearchable
                    noOptionsMessage={() => "No drivers found"}
                  />
                </div>
               
              </div>
            </div>

            <div className="row">
              <div className="col-md-3"></div>
              <div className="col-md-6">
                <a
                  onClick={getDetails}
                  style={buttonsyle}
                  type="button"
                  className="btn-demo add"
                >
                  Submit
                </a>
              </div>
            </div>
            <p style={{ color: "red", marginTop: "2%" }}>{errormsg}</p>
          </div>
          <div className="col-md-4">
            {shipmentDetails.length > 0 && (
              <div className="row">
                <div className="col-md-11">
                  {/* Use inline-block for alignment */}
                  <div className="text-right">
                    {/* Delivered Link */}
                    {hasDeliveredRecords && (
                      <div
                        className="inline-block"
                        style={{ marginRight: "10px", marginBottom: "5px" }}
                      >
                        <CSVLink
                          data={csvDataForDownload}
                          headers={csvHeaders}
                          filename="shipment_details_delivered.csv"
                          className="text-primary font-weight-bold"
                        >
                          <i className="fa fa-download" /> Delivered
                        </CSVLink>
                      </div>
                    )}

                    {/* Pending Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForDownloadPending}
                        headers={csvHeaders}
                        filename="shipment_details_pending.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> Pending
                      </CSVLink>
                    </div>

                    {/* Download COD Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForCOD}
                        headers={csvHeaders}
                        filename="shipment_details_cod.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> COD
                      </CSVLink>
                    </div>

                    {/* Download NON COD Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForNonCod}
                        headers={csvHeaders}
                        filename="shipment_details_non_cod.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> Non COD
                      </CSVLink>
                    </div>

                    {/* Download All Orders Link */}
                    <div
                      className="inline-block"
                      style={{ marginRight: "10px", marginBottom: "5px" }}
                    >
                      <CSVLink
                        data={csvDataForDownloadAll}
                        headers={csvHeaders}
                        filename="shipment_details.csv"
                        className="text-primary font-weight-bold"
                      >
                        <i className="fa fa-download" /> All
                      </CSVLink>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
        </div>

        <div className="row">
          <div className="col-md-11">
            {loading && <p>Loading shipment details...</p>}

            {shipmentDetails.length > 0 && (
              <div>
               

                <h4 style={{ textAlign: "left" }}>Track Summary:</h4>
                <div className="row">
                  <div className="col-md-4" style={{ float: "right" }}>
                    <select
                      style={{ float: "right", marginBottom: "3%" }}
                      onChange={handleFilterChange}
                    >
                      <option value="All">All</option>
                      <option value="COD">COD</option>
                      <option value="NON COD">NON COD</option>
                      <option value="DELIVERED">Delivered</option>
                      <option value="PENDING">Pending</option>
                    </select>
                  </div>
                </div>
                <div
                  className="shipdata"
                  style={{
                    background: "#5583af59",
                    maxHeight: "500px", // Adjust the height limit as needed
                    overflowY: "auto", // Enables vertical scrolling
                    // padding: '10px',   // Optional: Add some padding for better visuals
                    border: "1px solid #ccc", // Optional: Add a border for separation
                    // marginBottom:'3%'
                  }}
                >
                  <table className="table  table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>AWB</th>
                        <th>Status</th>
                        <th>Last Transit Date</th>
                        <th>Last Transit Time</th>
                        <th>Courier</th>
                        <th>Courier Team</th>
                        <th>Courier Zone</th>
                        <th>Shipper</th>
                        <th>Consignee</th>

                        <th>Payment Type</th>
                        <th>COD</th>
                        <th>Cash Collected</th>
                        <th>Cash Difference</th>
                        <th>Updated By</th>
                      </tr>
                    </thead>
                    <tbody>
                      {filteredShipmentDetails.map((data, index) => (
                        <tr key={index}>
                          <td>
                            {" "}
                            {data.bookingId}
                            <br />
                            <p
                              style={{
                                display: "inline-block",
                                width: "15px",
                                height: "15px",
                                borderRadius: "50%",
                                backgroundColor:
                                  data.type === "PICK_UP"
                                    ? "blue"
                                    : data.type === "DROP"
                                    ? "green"
                                    : "gray",
                                color: "white",
                                textAlign: "center",
                                lineHeight: "15px", // To center the text vertically
                                fontSize: "10px",
                                fontWeight: "bold",
                              }}
                            >
                              {data.type === "PICK_UP"
                                ? "P"
                                : data.type === "DROP"
                                ? "D"
                                : ""}
                            </p>
                          </td>
                          <td>{data.latestStatus}</td>
                          {/* <td>{new Date(data.lastUpdatedDate).toLocaleDateString()}</td> */}
                          <td style={{ width: "150px" }}>
                            {
                              new Date(data.lastUpdatedDate)
                                .toISOString()
                                .split("T")[0]
                            }
                          </td>

                          <td>
                            {new Date(
                              data.lastUpdatedDate
                            ).toLocaleTimeString()}
                          </td>

                          <td>{`${driver} - ${data.courier}`}</td>

                          <td>{driverdata.team}</td>
                          <td>{driverdata.zone}</td>
                          <td>{data.shipperDetails?.name || ""}</td>
                          <td>{data.consigneeDetails?.name || ""}</td>

                          <td>{data.paymentType}</td>
                          <td>
                            {data.latestStatus?.toLowerCase() === "delivered"
                              ? data.codDetails
                              : 0}
                          </td>
                          <td>
                            {data.latestStatus?.toLowerCase() === "delivered"
                              ? data.cashCollected
                              : 0}
                          </td>
                          <td>
                            {data.latestStatus?.toLowerCase() === "delivered"
                              ? data.codDetails - data.cashCollected
                              : 0}
                          </td>
                          <td>{data.updatedBy}</td>
                        </tr>
                      ))}
                    </tbody>
                    {selectedPaymentType !== "NON COD" ? (
                      <tfoot style={{ background: "#fff" }}>
                        <tr>
                          <td
                            colSpan="11"
                            style={{ textAlign: "right", fontWeight: "bold" }}
                          >
                            Total COD:
                          </td>
                          <td>{totalCod}</td>
                        </tr>
                        <tr>
                          <td
                            colSpan="11"
                            style={{ textAlign: "right", fontWeight: "bold" }}
                          >
                            Actual Collected:
                          </td>
                          <td>{getTotalActualCollected()}</td>
                        </tr>
                      </tfoot>
                    ) : (
                      ""
                    )}
                  </table>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
